import {
  createRuntimeEnvSchemaContext,
  resolveEnvSchema,
  type EnvSchema,
  type SchemaDefinition,
} from "./schema-definition";
import type { z } from "zod";

type ParseEnvSchemaOptions = {
  source?: Record<string, unknown>;
};

export function parseEnvSchema<TSchema extends EnvSchema>(
  definition: SchemaDefinition<TSchema>,
  options: ParseEnvSchemaOptions = {}
): z.output<TSchema> {
  const source = options.source ?? process.env;
  return resolveEnvSchema(
    definition,
    createRuntimeEnvSchemaContext(source)
  ).parse(source);
}
